import { Box, Card, List } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { CreditLayoutTab } from './creditsLayoutTab';
import { DescriptionTab } from './Description/Description';
import { DiscountsLayout } from './discountsLayoutTab';
import EmailCountdown from './emailCountdown';
import { FeaturedCompetitions } from './FeaturedCompetitions/FeaturedCompetitions';
import { GeneralCouponsTab } from './generalCouponsTab';
import GeneralFreeTickets from './generalFreeTickets';
import LegalStaffTab from './legalStaffLayoutTab';
import './style.css';
import Subscriptions from './Subscriptions';
import GeneralBundles from './generalBundles';
import { getLandingGeneral } from '../../helpers/getGeneral';
import { useSelector, useDispatch } from 'react-redux';
import {
  setFreeTickets,
  setOtherLandingData,
} from '../../redux/actions/propertyActions';

enum GeneralTabsIds {
  Documentations = 'documentations',
  Credits = 'credits',
  FreeTickets = 'freeTickets',
  Bundles = 'bundles',
  Discounts = 'discounts',
  Coupons = 'coupons',
  EmailCountdown = 'emailCountdown',
  FeaturedCompetitions = 'featuredCompetitions',
  Description = 'description',
  Subscriptions = 'subscriptions',
}
const Tabs = [
  // {
  //   title: 'Discount',
  //   id: GeneralTabsIds.Discounts,
  // },
  // {
  //   title: 'Credits',
  //   id: GeneralTabsIds.Credits,
  // },
  {
    title: 'Bundles',
    id: GeneralTabsIds.Bundles,
  },
  {
    title: 'Free Tickets',
    id: GeneralTabsIds.FreeTickets,
  },
];
const GeneralLayout = (props: any) => {
  const [currentTabId, setCurrentTabId] = useState<string>(
    GeneralTabsIds.Bundles
  );

  if (!props.pageType) {
    return null;
  }
  return (
    <Box className='generalTabMainWrapper'>
      <Box className='generalTabsWrapper'>
        <List disablePadding={true}>
          {Tabs.map((i, index) => {
            return (
              <Box onClick={() => setCurrentTabId(i.id)} key={index}>
                <div
                  className={`generalTabWrapper ${
                    i.id === currentTabId ? 'active' : ''
                  }`}
                >
                  {i.title}
                </div>
              </Box>
            );
          })}
        </List>
      </Box>
      <Box className='generalTabContentWrapper'>
        {/* {currentTabId === GeneralTabsIds.Discounts ? (
          <DiscountsLayout pageType={props.pageType} />
        ) : null}
        {currentTabId === GeneralTabsIds.Credits ? (
          <CreditLayoutTab pageType={props.pageType} />
        ) : null} */}
        {currentTabId === GeneralTabsIds.Bundles ? (
          <Card>
            <GeneralBundles pageType={props.pageType} />
          </Card>
        ) : null}
        {currentTabId === GeneralTabsIds.FreeTickets ? (
          <Card>
            <GeneralFreeTickets pageType={props.pageType} />
          </Card>
        ) : null}
      </Box>
    </Box>
  );
};
export default GeneralLayout;
